import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { BreadcrumbsV2 } from '@uncinc/react-drupal-core';

import { ParagraphsRenderer } from '../../../components';
import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { NodeOverviewPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface OverviewPageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeOverviewPage: React.FC<OverviewPageProps> = ({ entity, className }) => {
  const {
    breadcrumbsColClasses,
    heroTextColClasses,
  } = useLayoutVariables('overviewPage');

  const classes = classNames('Node', 'NodeOverviewPage', className);
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeOverviewPage__hero">
        <Container>
          <div className="row">
            <div className={breadcrumbsColClasses}>
              <BreadcrumbsV2 hideOnHighestLevel />
            </div>
          </div>
          <div className="row">
            <div className={heroTextColClasses}>
              <h1 className="NodeOverviewPage__title" itemProp="title">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="NodeOverviewPage__body body--large"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>
          </div>
        </Container>
      </div>

      <ParagraphsRenderer className="NodeOverviewPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeOverviewPage;
